var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgAiAgentsCategory = function SvgAiAgentsCategory(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    fill: "currentColor"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#AiAgentsCategory_svg__AiAgentsCategory_svg__clip0_1494_7727)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.16 19.5a2.38 2.38 0 011.711.732c.454.47.709 1.105.709 1.768 0-.663.255-1.299.709-1.768A2.382 2.382 0 0121 19.5a2.382 2.382 0 01-1.711-.732 2.543 2.543 0 01-.71-1.768c0 .663-.254 1.299-.708 1.768a2.382 2.382 0 01-1.711.732zm0-15a2.38 2.38 0 011.711.732c.454.47.709 1.105.709 1.768 0-.663.255-1.299.709-1.768A2.382 2.382 0 0121 4.5a2.382 2.382 0 01-1.711-.732A2.542 2.542 0 0118.579 2c0 .663-.254 1.299-.708 1.768a2.382 2.382 0 01-1.711.732zm-5.9 15c0-1.99.765-3.897 2.127-5.303A7.145 7.145 0 0117.521 12a7.145 7.145 0 01-5.134-2.197A7.627 7.627 0 0110.26 4.5c0 1.99-.764 3.897-2.126 5.303A7.145 7.145 0 013 12c1.926 0 3.772.79 5.134 2.197a7.627 7.627 0 012.127 5.303z",
    fill: "#fff",
    stroke: "#6E7D8C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6E7D8C",
    d: "M18 19h1v1h-1zm0-15h1v1h-1z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "AiAgentsCategory_svg__AiAgentsCategory_svg__clip0_1494_7727"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 24,
    width: 24,
    height: 24,
    rx: 4,
    transform: "rotate(-180 24 24)",
    fill: "#fff"
  })))));
};
export default SvgAiAgentsCategory;